import {Component, OnInit} from '@angular/core';
import {Params, ActivatedRoute} from "@angular/router";
import {IMyOptions} from 'mydatepicker';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {Subscription} from "rxjs";
import {User} from "../type/user";
import {Company} from "../type/company";
import {CompanyStatus} from "../type/company-status";
import {Category} from "../type/category";

@Component({
    selector: 'app-companies',
    templateUrl: './companies.component.html',
})
export class CompaniesComponent implements OnInit {
    node = 'company';
    companyStatusNode = 'company-status';
    companyCategoryNode = 'company-category';
    usersNode = 'user';

    clear = '';
    isChecked = false;
    checkedList = [];
    users: [User] = [User];
    company: Company = Company;
    //selectedCompany: Company = Company;
    companies: [Company] = [Company];
    companyMetaData = {"totalItems": "", "limit": "", "offset": ""};
    companyStatuses: [CompanyStatus] = [CompanyStatus];
    companyCategories: [Category] = [Category];

    companySubCategories: [Category] = [Category];

    queryString = 'all';
    value: Date;
    query = {
        "search": "",
        "search_field": "",
        "company_status_id": "",
        "company_category_id": "",
        "company_sub_category_id": "",
        "created_at_start": {"formatted": ""},
        "created_at_end": {"formatted": ""},
        "last_contacted_start": {"formatted": ""},
        "last_contacted_end": {"formatted": ""},
        "due_date": "",
        "user_id": "",
        "approved_status":"",
        "priority_level": "",
        "order_by": "company_id",
        "order": "desc"
    };
    modalData = {
        'company_id':'',
        'company_name': '',
        'company_status_id':'',
        'company_quota':'12',
        'company_remark':'',
        'priority_level':'',
        'due_date':'',
        'last_contacted_by':'',
        'last_contacted_at':''

    };

    display: boolean = false;

    myDatePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
    };

    constructor(private apiService: ApiService,
                private dataService: DataService,
                private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.dataService.refresh();
        //get the data
        this.route.params
            .subscribe(
                (params: Params) => {
                    if (params['status']) {
                        this.queryString = 'company_status=' + params['status'];
                        this.getUsingQuery();
                    } else {
                        this.getUsingQuery();
                    }

                }
            );
        this.getCompanyStatuses();
        this.getCompanyCategories();
        // this.getCompanySubCategories();
        this.getUsers();
    }

    getUsingQuery(): void {
        this.queryString = '&search=' + this.query.search
            + '&search_field=' + this.query.search_field
            + '&company_status_id=' + this.query.company_status_id
            + '&company_category_id=' + this.query.company_category_id
            + '&company_sub_category_id=' + this.query.company_sub_category_id
            + '&created_at_start=' + ((this.query.created_at_start.formatted != undefined) ? this.query.created_at_start.formatted : '')
            + '&created_at_end=' + ((this.query.created_at_end.formatted != undefined) ? this.query.created_at_end.formatted : '')
            + '&last_contacted_start=' + ((this.query.last_contacted_start.formatted != undefined) ? this.query.last_contacted_start.formatted : '')
            + '&last_contacted_end=' + ((this.query.last_contacted_end.formatted != undefined) ? this.query.last_contacted_end.formatted : '')
            + '&due_date=' + this.query.due_date
            + '&user_id=' + this.query.user_id
            + '&approved_status=' + this.query.approved_status
            + '&priority_level=' + this.query.priority_level
            + '&order_by=' + this.query.order_by
            + '&order=' + this.query.order
            + '&offset=' + this.companyMetaData.offset
            + '&limit=' + this.companyMetaData.limit;
        this.apiService.getUsingQuery(this.node, this.queryString)
            .subscribe(
                (response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.companies = [{"company_id": ""}];
                        this.companyMetaData = {"totalItems": "0", "limit": "0", "offset": "0"};
                    } else {
                        this.companies = response.json().data;
                        this.companyMetaData = response.json().metaData;
                    }
                },
                (error) => {
                    this.companies = [Company];
                }
            );
    }

    onDelete() {
        if (confirm('Are you absolutely sure you want to delete?')) {
            this.apiService.delete(this.node, this.checkedList)
                .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Unable to delete company');
                    } else {
                        this.getUsingQuery();
                        this.isChecked = false;
                        this.checkedList = [];
                        alert('Company Deleted Successfully');
                    }
                });
        }
    }

    getUsers() {
        this.apiService.getAll(this.usersNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.users = [User];
                } else {
                    this.users = response.json().data;
                }
            })
    }

    getCompanyStatuses() {
        this.apiService.getAll(this.companyStatusNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.companyStatuses = [CompanyStatus];
                } else {
                    this.companyStatuses = response.json().data;
                }
            });
    }

    getCompanyCategories() {
        this.apiService.getAll(this.companyCategoryNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.companyCategories = [Category];
                } else {
                    this.companyCategories = response.json().data;
                }
            });
    }

    getCompanySubCategories(cat_id) {
        this.apiService.getSubCatOnly(this.companyCategoryNode,cat_id)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.companySubCategories = [Category];
                } else {
                    this.companySubCategories = response.json().data;
                }
            });
    }

    onFormSubmit() {
        this.companyMetaData.offset = "0";
        this.getUsingQuery();
    }

    onPageChange(offset) {
        this.companyMetaData.offset = offset;
        this.getUsingQuery();
    }

    updateCheckList(id) {
        if (this.checkedList.indexOf(id) == -1) {
            this.checkedList.push(id);
        } else {
            this.checkedList.splice(this.checkedList.indexOf(id), 1);
        }
    }


    toggleCheckBox() {
        this.isChecked = !this.isChecked;
        if (this.isChecked == true) {
            this.checkedList = this.companies.map(function (a) {
                return a.company_id;
            });
        } else {
            this.checkedList = [];
        }
    }

    resetModalData(companyName, companyId) {
        this.modalData.company_id = companyId;
        this.modalData.company_name = companyName;
    }

    resetCheckList() {
        this.isChecked = false;
        this.checkedList = [];
    }


    onQuickUpdate(formData) {
        var data = {
            company_status_id: formData.value.company_status_id,
            company_quota: formData.value.company_quota,
            remarks: [{"company_remark": formData.value.company_remark}],
            priority_level: formData.value.priority_level,
            due_date: formData.value.due_date.formatted,
            stop_following: formData.value.stop_following,
            last_contacted_by: formData.value.last_contacted_by,
            last_contacted_at: formData.value.last_contacted_at.formatted
        };

        var ids = [this.modalData.company_id];
        if (this.checkedList.length > 0) {
            ids = this.checkedList;
        }

        this.apiService.update(this.node, ids, data)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    alert('Unable to update company');
                } else {
                    this.getUsingQuery();
                    this.isChecked = false;
                    this.checkedList = [];
                    alert('Company updated Successfully');
                }
            },
            (error) => alert('Unable to update company')
            );
    }

    clearData() {
        this.clear = '';
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }
}



// WEBPACK FOOTER //
// ./src/app/companies/companies.component.ts